import RecordsIcon from '../../../../assets/img/RecordsIcom0.svg';
import ProjectsIcon from '../../../../assets/img/ProjectsIcon.svg';
import CommVergeIcon from '../../../../assets/img/acumen_commverge0.png';
import FinSIcon from '../../../../assets/img/valuation_new1.png';
import LeaseIcon from '../../../../assets/img/LeaseIcon.svg';
import AirworthinessIcon from '../../../../assets/img/CAMO_Final_Logo.svg';
import MaintenanceIcon from '../../../../assets/img/MaintenanceIcon.svg';
import OpticIcon from '../../../../assets/img/optic_logo.svg';

export const dateMonthYearDateFormat = 'DD MMM YYYY';

export const defaultApplicationAccent = { main: '#6252c7', soft: '#f0edff', glow: 'rgba(98, 82, 199, 0.16)' };

export const applicationAccentOptions = [
    { keywords: ['lease management'], accent: defaultApplicationAccent },
    { keywords: ['projects management', 'project management'], accent: { main: '#dd6b20', soft: '#fff3e8', glow: 'rgba(221, 107, 32, 0.14)' } },
    { keywords: ['records dataroom', 'records'], accent: { main: '#087ea4', soft: '#e6f7fb', glow: 'rgba(8, 126, 164, 0.14)' } },
    { keywords: ['maintenance management', 'maintenance'], accent: { main: '#c44f76', soft: '#fcecf2', glow: 'rgba(196, 79, 118, 0.14)' } },
    { keywords: ['commverge'], accent: { main: '#1676a5', soft: '#eaf5fa', glow: 'rgba(22, 118, 165, 0.14)' } },
    { keywords: ['fin-s', 'fin s'], accent: { main: '#db8c12', soft: '#fff5df', glow: 'rgba(219, 140, 18, 0.15)' } },
    { keywords: ['airworthiness'], accent: { main: '#16866f', soft: '#e8f8f3', glow: 'rgba(22, 134, 111, 0.14)' } },
    { keywords: ['teardown', 'consignment', 'optic'], accent: { main: '#70843b', soft: '#f1f5e7', glow: 'rgba(112, 132, 59, 0.14)' } }
];

export const applicationColors = applicationAccentOptions.map(option => option.accent.main);
export const upcomingFeatureColor = '#6252c7';

export const upcomingFeatures = [
    { title: 'AI-powered lease abstraction', application: 'Lease Management', eta: 'Aug 2026', description: 'Leverage AI to automate lease abstraction processes and improve accuracy.' },
    { title: 'Smart records search', application: 'Records Dataroom', eta: 'Aug 2026', description: 'Enhance search capabilities with intelligent filtering and sorting.' },
    { title: 'Fleet health dashboard', application: 'Airworthiness', eta: 'Aug 2026', description: 'Monitor and analyze fleet health metrics in real-time.' }
];

export const releaseArtworkOptions = [
    { keywords: ['records dataroom', 'records'], artwork: { src: RecordsIcon, alt: 'Records Dataroom' } },
    { keywords: ['project management', 'projects management'], artwork: { src: ProjectsIcon, alt: 'Projects Management' } },
    { keywords: ['maintenance management', 'maintenance'], artwork: { src: MaintenanceIcon, alt: 'Maintenance Claim Management' } },
    { keywords: ['commverge'], artwork: { src: CommVergeIcon, alt: 'CommVerge' } },
    { keywords: ['fin-s', 'fin s'], artwork: { src: FinSIcon, alt: 'fin-S' } },
    { keywords: ['lease management'], artwork: { src: LeaseIcon, alt: 'Lease Management' } },
    { keywords: ['airworthiness management', 'airworthiness'], artwork: { src: AirworthinessIcon, alt: 'Airworthiness Management' } },
    { keywords: ['teardown', 'consignment', 'optic'], artwork: { src: OpticIcon, alt: 'Teardown and Consignment Program Management' } }
];
